import session from "@/api/session";

export default {
  fetchUpfrontCostsById(pid) {
    return session.get(`/products/${pid}/upfront-charges-credits/`);
  },
  updateUpfrontCostsById(pid,data) {
    return session.patch(`/products/${pid}/upfront-charges-credits/`,JSON.stringify(data));
  },
}
